<template>
  <div>

    <div class="alert alert-primary" role="alert" v-if="message">
      {{ message }}
    </div>

    <div class="form-group mb-4">
      <label for="searchGoodsId">Goods ID or EAN</label>
      <input type="text" name="searchGoodsId" class="form-control" id="searchGoodsId" value="" autofocus ref="input">
    </div>

    <div class="form-group mb-4">
      <div id="scanner" ref="scanner"></div>
    </div>

  </div>
</template>

<script>
import Quagga from 'quagga'

export default {
  data() {
    return {
      scanner: null,
      results: [],
      message: ''
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      this.scanner = Quagga
      this.scanner.init({
        inputStream : {
          name : 'Live',
          type : 'LiveStream',
          target: this.$refs.scanner
        },
        decoder : {
          readers : ['ean_reader'],
          debug: {
            drawBoundingBox: true,
            showFrequency: true,
            drawScanline: true,
            showPattern: true
          }
        },
        locate:true
      }, err => {
        if (err) {
          console.error(err)
          return
        }
        this.scanner.start()
      })
      this.addCallbacks()
    },

    addCallbacks() {
      this.scanner.onProcessed(this.process)
      this.scanner.onDetected(this.detect)
    },

    process(result) {
      let drawingCtx = this.scanner.canvas.ctx.overlay
      let drawingCanvas = this.scanner.canvas.dom.overlay

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')))
          result.boxes.filter(box => {
            return box !== result.box
          }).forEach(box => {
            this.scanner.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: 'green', lineWidth: 2})
          })
        }

        if (result.box) {
          this.scanner.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: '#00F', lineWidth: 2})
        }

        if (result.codeResult && result.codeResult.code) {
          this.scanner.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3})
        }
      }
    },

    orderByOccurence(array) {
      return array.sort((a,b) =>
        array.filter(v => v === a).length
        - array.filter(v => v === b).length
      ).pop()
    },

    detect(result) {
      this.results.push(result.codeResult.code)
      if (this.results.length > 30) {
        this.scanner.stop()
        this.$refs.input.value = this.orderByOccurence(this.results)
        this.$refs.scanner.style.display = 'none'
        this.message = 'EAN kód bol zosnímaný. Pokračujte ďalej'
        this.results = []
      }
    },
  },
}
</script>
